import { render, staticRenderFns } from "./SalesNoteCreateUpdate.vue?vue&type=template&id=45e88d16&scoped=true&"
import script from "./SalesNoteCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./SalesNoteCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SalesNoteCreateUpdate.vue?vue&type=style&index=0&id=45e88d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e88d16",
  null
  
)

export default component.exports